export const getMyProfileGamerService = async () => {
  //return privateRequest.get(`${ConfEnv.API_URL.API_GAMIFICATION}/missions/me`);
  return {
    data: {
      data: {
        points: 0,
        level: "Novato",
      },
    },
  };
};
